import React from 'react';

import classNames from 'classnames';

import { CONTRACT_MANAGEMENT_TAB_IDS, detailMoney, SWITCH_CONTRACT_MANAGEMENT_TAB_EVENT } from './contractDashboardHelpers';

import { useCustomEvent } from 'Hooks/useGlobalDOMEvents';

/**
 * IB-703 — a single "unsigned contracts" callout tile. When there are unsigned contracts it
 * takes the red/warning treatment from the mockup banner; when the bucket is empty the alarm is
 * suppressed (neutral tile). The "Review" action switches to the matching Contract Management
 * sub-tab via a custom DOM event (ProcurementContractManagementTab listens for it).
 */
const UnsignedTile = ({ label, bucket, currencySymbol, targetTabId }) => {
    const switchTab = useCustomEvent({ eventName: SWITCH_CONTRACT_MANAGEMENT_TAB_EVENT });

    const count = bucket?.count ?? 0;
    const value = bucket?.value ?? 0;
    const suppliers = bucket?.suppliers ?? 0;
    const hasUnsigned = count > 0;

    return (
        <div
            className={classNames('tw-flex tw-items-center tw-gap-4 tw-rounded-lg tw-border tw-px-5 tw-py-4', {
                'tw-border-red-25 tw-bg-red-25 tw-bg-opacity-40': hasUnsigned,
                'tw-border-grey tw-bg-white': !hasUnsigned,
            })}
        >
            <div className={classNames('tw-shrink-0 tw-text-4xl tw-font-bold tw-leading-none', hasUnsigned ? 'tw-text-red' : 'tw-text-charcoal-50')}>
                {count}
            </div>
            <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-1">
                <span className="tw-text-sm tw-font-semibold tw-text-charcoal">
                    {$t('{{count}} {{type}} contracts not yet signed', { count, type: label })}
                </span>
                <span className="tw-text-xs tw-text-charcoal-50">
                    {$t('{{value}} of contracted value · across {{count}} suppliers', {
                        value: detailMoney(currencySymbol, value),
                        count: suppliers,
                    })}
                </span>
            </div>
            {hasUnsigned && (
                <button
                    type="button"
                    onClick={() => switchTab({ tabId: targetTabId })}
                    className="tw-shrink-0 tw-rounded-lg tw-bg-blue tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-dark-blue"
                >
                    {$t('Review')}
                </button>
            )}
        </div>
    );
};

const UnsignedContractTiles = ({ unsigned, currencySymbol }) => (
    <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-3">
        <UnsignedTile label={$t('revenue')} bucket={unsigned?.revenue} currencySymbol={currencySymbol} targetTabId={CONTRACT_MANAGEMENT_TAB_IDS.revenue} />
        <UnsignedTile
            label={$t('expenditure')}
            bucket={unsigned?.expenditure}
            currencySymbol={currencySymbol}
            targetTabId={CONTRACT_MANAGEMENT_TAB_IDS.expenditure}
        />
    </div>
);

export default UnsignedContractTiles;
